import { isAutomatedWizard } from "app/components/appwizard/component-wizards/wizards/source/database-reader/app-services";
import APPTYPES from "src/modules/apps/pages/create-app-page-templates/services/create-app-page-app-types.const.json";

import { BackboneValidationMethods } from "./validation-methods/backbone-validation-methods";
import { ReactValidationMethods } from "./validation-methods/react-validation-methods";

import type { GenerateValidationListProps } from "./validation-steps.types";

// Neither flow has a templateID at the privilege-check step, so resolve the
// wizardType from the flow flags (same APPTYPES set getWizardTypeFromURL yields).
const getWizardType = (props: GenerateValidationListProps): string => {
    const isAutomated = props.isAutomatedAppFlow ?? isAutomatedWizard();
    return isAutomated ? APPTYPES.AUTOMATEDILCDC : props.isCDC ? APPTYPES.CDC : APPTYPES.IL;
};

export const hasAutomatedCDCPermissionCheck = (type: string) => type !== "SALESFORCE";

export const hasPrivilegeCheck = (type: string) => {
    switch (type) {
        case "ORACLE":
        case "MSJET":
        case "OJET":
        case "MARIADB":
        case "MARIADBXPAND":
        case "SQLSERVER":
        case "MYSQL":
        case "POSTGRES":
        case "YUGABYTE":
            return true;
        default:
            return false;
    }
};

export const validateConnectionStep = (
    props: GenerateValidationListProps,
    checkPrimaryDatabase = false
) => 
    props.isPureReactView
        ? ReactValidationMethods.ValidateConnection(props)
        : BackboneValidationMethods.ValidateConnection(
              props.model,
              props.isCDC ?? false,
              checkPrimaryDatabase
          );
        

export const fetchSchemasStep = (props: GenerateValidationListProps) =>
    props.isPureReactView
        ? ReactValidationMethods.GetSchemas(props)
        : BackboneValidationMethods.GetSchemas(
              props.model,
              props.isCDC ?? false,
              props.type
          );

export const checkCDCPermissionsStep = (props: GenerateValidationListProps) =>
    props.isPureReactView
        ? ReactValidationMethods.CheckCDCConfigurations(props)
        : BackboneValidationMethods.CheckCDCPermissions(props.model);

export const privilegeCheckStep = (props: GenerateValidationListProps) => {
    const wizardType = getWizardType(props);
    return props.isPureReactView
        ? ReactValidationMethods.CheckPrivileges(props, wizardType)
        : BackboneValidationMethods.CheckPrivileges(props.model, props.type, wizardType);
};

